export default "__VITE_ASSET__0ee4c1e0__"